export const GLOBAL_STATE_INDEX_ID = 'GLOBAL_STATE_INDEX_ID';
